import request from '@/axios'

// C-播报-01-获取播列表
export function getMessageList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/message/getMessageList',
    method: 'post',
    data
  })
}

// C-播报-02-获取播报详情
export function getMessageInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/sidebar/message/getMessageInfo',
    method: 'post',
    data
  })
}

// C-播报-02-获取播报详情
export function sendMessage(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/message/sendMessage',
    method: 'post',
    data
  })
}

// C-播报-04-获取播报个数
export function getMessageCount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/message/getMessageCount',
    method: 'post',
    data
  })
}

// D-客户-07-(客诉详情)客户星评
export function customerEvaluate(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/complaint/customerEvaluate',
    method: 'post',
    data
  })
}
